// src/services/authContext.js
import { useMsal } from '@azure/msal-react';
import { gql } from '@apollo/client';
import { useQuery } from '@apollo/client/react';

export const ME_QUERY = gql`
  query Me {
    me {
      id
      isAdmin
      isDeveloper
    }
  }
`;

export function useMeQuery() {
  const { data, loading } = useQuery(ME_QUERY, { fetchPolicy: 'cache-first' });
  return {
    isAdmin: data?.me?.isAdmin ?? false,
    isDeveloper: data?.me?.isDeveloper ?? false,
    loading,
  };
}

export function useAuthContext() {
  const { instance, accounts } = useMsal();
  const account = accounts?.[0] ?? null;
  const roles = account?.idTokenClaims?.roles ?? [];
  const isAdmin = roles.includes('Admin');
  const isDeveloper = roles.includes('Developer');

  const currentUser = {
    id: account?.homeAccountId ?? null,
    username: account?.username ?? null,
    roles,
  };

  return { msalInstance: instance, account, isAdmin, isDeveloper, currentUser };
}
